import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['toggleAll', 'checkbox']

  connect() {
    this.toggleAllTargets.forEach((toggleAll) =>
      this.sync({ currentTarget: toggleAll })
    )
  }

  toggleCheckboxes({ currentTarget }) {
    for (const checkbox of this.checkboxesFor(currentTarget)) {
      checkbox.checked = currentTarget.checked
    }
  }

  sync({ currentTarget }) {
    const toggleAll = this.toggleAllFor(currentTarget)
    if (!toggleAll) return

    toggleAll.checked = this.allCheckedFor(toggleAll)
    toggleAll.indeterminate =
      !toggleAll.checked && this.anyCheckedFor(toggleAll)
  }

  allCheckedFor(toggleAll) {
    return this.checkboxesFor(toggleAll).every((checkbox) => checkbox.checked)
  }

  anyCheckedFor(toggleAll) {
    return this.checkboxesFor(toggleAll).some((checkbox) => checkbox.checked)
  }

  toggleAllFor(element) {
    const group = this.groupFor(element)
    return this.toggleAllTargets.find(
      (toggleAll) => this.groupFor(toggleAll) === group
    )
  }

  checkboxesFor(element) {
    const group = this.groupFor(element)
    return this.checkboxTargets.filter(
      (checkbox) => this.groupFor(checkbox) === group
    )
  }

  groupFor(element) {
    return element?.dataset.triStateGroup || 'default'
  }
}
